<!--
 * @Author: hfxie
 * @Date: 2021-01-01 17:10:10
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-07-03 17:43:54
 * @Description: 甘特图主组件
-->

<template>
  <div
    class="common-gantt"
    ref="commonGantt"
    :data-page-id="uuid"
    :data-filltype="$store.state.viewSchem.timelineFillType"
    :id="uuid"
    :style="ganttTotalWidth"
  >
    <!-- DEBUG操作栏 -->
    <div class="gantt-opts hide" data-html2canvas-ignore>
      <Select
        size="small "
        @change="ChangeCellUnitType($event)"
        v-model="selectCellUnitType"
        :placeholder="timelineText"
      >
        <Option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </Option>
      </Select>
<!--      数据比例:{{ $store.state.cellScale }}当前比例:{{ $store.getters.realCellScale }} 基准宽度:{{ $store.state.cellWidth}}-->
      {{$store.state.langMap.cellScaleText}}{{ $store.state.cellScale }}{{$store.state.langMap.realCellScaleText}}{{ $store.getters.realCellScale }} {{$store.state.langMap.cellWidthText}}{{ $store.state.cellWidth}}
      <el-input
        style="width: 150px"
        size="small"
        type="number"
        max="1000"
        min="10"
        step="10"
        :placeholder="newScaleText"
        v-model="newScale">
      </el-input>
      <Button type="primary" size="small " round @click="Scale('setScale')">{{$store.state.langMap.setScaleText}}</Button>
      <Button type="primary" size="small " round @click="Scale">{{$store.state.langMap.magnifyText}}</Button>
      <Button type="primary" size="small " round @click="Scale('small')">{{$store.state.langMap.shrinkText}}</Button>
      <Button type="primary" size="small " round @click="Print">{{$store.state.langMap.printText}}</Button>
      <Button type="primary" size="small " round @click="SetSelectStatusArea">{{$store.state.langMap.batchSelectText}}</Button>
      <Button type="primary" size="small " round @click="SetSearch"><i class="el-icon-search" :title="startSearchText"></i></Button>
      <Button type="primary" size="small " round @click="Search(-1)"><i class="el-icon-arrow-up" :title="preSearchText"></i></Button>
      <Button type="primary" size="small " round @click="Search(1)"><i class="el-icon-arrow-down" :title="nextSearchText"></i></Button>
      <Button type="primary" size="small " round @click="CancelSearch"><i class="el-icon-close" :title="closeSearchText"></i></Button>
      <iframe width='100%' height='200px' style='display: none;' class='pmtsIframe'></iframe>
    </div>
    <!-- 甘特图 -->
    <Gantt :noTop="!$store.state.viewSchem.ganttHeadShow" />
    
    <!-- 加载 -->
    <div
      data-html2canvas-ignore
      class="loading-mask" 
      v-show="$store.state.dataLoadingStatus"
      @click.stop
      @touchmove.prevent
    >
      <CqLoading />
    </div>

    <!-- 横道拖拽滚动换页区 -->
    <!-- <div
      v-if="false"
      v-show="isDragging && false"
      class="panel panel-pre"
      :style="{
        left: $store.getters.WBSLeft + 'px',
      }"
      @dragenter.stop.prevent="DragEnter($event, -1)"
      @dragleave.stop.prevent="DragLeave($event)"
    ></div>
    <div
      v-if="false"
      v-show="(isDragging || moveLinkFlag || true) && false"
      class="panel panel-next"
      @dragenter.stop.prevent="DragEnter($event, 1)"
      @dragleave.stop.prevent="DragLeave($event)"
      @mouseover.stop="DragEnter($event, 1)"
      @mouseout.stop="DragLeave($event)"
    ></div> -->

  </div>
</template>

<script>
import CqLoading from "./components/CqLoading/CqLoading.vue";
import Gantt from "./components/Gantt/Gantt";
export default {
  name: "App",
  data() {
    return {
      options: [
        {
          value: "day",
          label: this.$store.state.langMap.dayOption,
        },
        {
          value: "hour",
          label: this.$store.state.langMap.hourOption,
        },
        {
          value: "week",
          label: this.$store.state.langMap.weekOption,
        },
        {
          value: "month",
          label: this.$store.state.langMap.monthOption,
        },
      ],
      selectCellUnitType: this.$store.state.cellUnitType,
      timelineText: this.$store.state.langMap.timelineText,
      newScaleText: this.$store.state.langMap.newScaleText,
      startSearchText: this.$store.state.langMap.startSearchText,
      preSearchText: this.$store.state.langMap.preSearchText,
      nextSearchText: this.$store.state.langMap.nextSearchText,
      closeSearchText: this.$store.state.langMap.closeSearchText,
      printDisabled: false,
      newScale: null,

      scrollTime: null,
    };
  },
  created() {},
  mounted() {
    console.log("common_gantt mounted: ", Date.now() - window.common_gantt_initStamp);
  },
  beforeUpdate(){
    window.gt1 =  Date.now();
    console.log("common_gantt beforeUpdate", window.gt1);
  },
  updated() {
    window.gt4 =  Date.now();
    console.log("common_gantt updated", window.gt4, "跟新控件耗时ms:", window.gt4 - window.gt1, "总耗时:", window.gt4 - window.common_gantt_initStamp);
  },

  methods: {
    ChangeCellUnitType(e) {
      this.$store.commit("setCellUnitType", e);
    },
    Scale(type) {
      const scale = (parseInt(this.newScale) >= 8 && parseInt(this.newScale) <= 1000) ? parseInt(this.newScale) : null;
      this.$store.dispatch(
        "changeCellScale",
        {
          type,
          scale,
        });
    },
    Print() {
      const pars = {
        "printType": 1, // 1: 打印全部 2: 当前屏
        "_vm": window[this.$store.state.uuid],
      };
      this.$store.dispatch("_sendPrintInfo", pars);
    },

    /* 拖拽调整内容区域滚动距离 */
    DragEnter(e, x) {
      const panel = this.$refs.commonGantt.getElementsByClassName("gantt-box")[0];
      // console.log("进入开始滚动", x, panel.scrollLeft);
      if (x > 0) {
        panel.scrollLeft += 10;
      } else {
        panel.scrollLeft -= 10;
      }
      this.scrollTime = window.setInterval(() => {
        if (x > 0) { // 右
          panel.scrollLeft += 10;
          if (
            this.scrollTime &&
            (panel.scrollLeft >= this.$store.getters.timesTotalWidth - (this.$store.getters.ganttWidth - this.$store.getters.WBSLeft))
          ) {
            window.clearInterval(this.scrollTime);
            this.scrollTime = null;
            // console.log("取消");
          }
        } else { // 左
          panel.scrollLeft -= 10;
          if (
            this.scrollTime &&
            panel.scrollLeft <= 0
          ) {
            window.clearInterval(this.scrollTime);
            this.scrollTime = null;
            // console.log("取消");
          }
        }
      }, 1000 / 60);
    },
    DragLeave() {
      window.clearInterval(this.scrollTime);
    },
    SetSelectStatusArea() {
      const mockData = {
        "selectedArr": [
          "pmts_wbs-1188212763508356096",
          "pmts_wbs-1203453762534899712",
          "pmts_wbs-1203453915744436224",
          "pmts_wbs-1203454109269636096",
          "pmts_wbs-1203463497875193856",
        ],
        "success": true,
        "methodName": "gtRefreshSelectNodesArea",
        "ganttType": "pageData",
        "message": "",
      };
      this.$store.commit("set_selectStatus_area", mockData);
    },
    SetSearch() {
      // 生效mock数据 url: "/api/initGantt_cq1",
      this.$store.dispatch("showSearchedTaskInit", [
        {
          "taskId": "5497050600423715558——Task",
          "endDate": 1647849505000,
          "startDate": 1647158305000,
          "curRow": 1,
          "groupId": "5497050600423715558",
        },
        {
          "taskId": "9104136706211224703——Task",
          "endDate": 1647849505000,
          "startDate": 1647158305000,
          "curRow": 1,
          "groupId": "9104136706211224703",
        },
        {
          "taskId": "6236069849250938907——Task",
          "endDate": 1647849505000,
          "startDate": 1647158305000,
          "curRow": 1,
          "groupId": "6236069849250938907",
        },
        {
          "taskId": "7989425696364967775——Task",
          "endDate": 1647849505000,
          "startDate": 1647158305000,
          "curRow": 1,
          "groupId": "7989425696364967775",
        },
        {
          "taskId": "5099065770737590768——Task",
          "endDate": 1647849505000,
          "startDate": 1647158305000,
          "curRow": 1,
          "groupId": "5099065770737590768",
        },

      ]);
    },
    Search(type) { // -1 和 1
      const searchedArr = this.$store.state.viewSchem.searchedList;
      if (searchedArr.length <= 0) {
        return;
      }
      let actNum = this.$store.state.searchedActNum + type;
      if (actNum < 0) {
        actNum = searchedArr.length - 1;
      } else if (actNum == searchedArr.length) {
        actNum = 0;
      }
      this.$store.dispatch("showSearchedTaskActNum", actNum);
    },
    CancelSearch() {
      this.$store.dispatch("hideSearchedTask").then((a) => {
        // console.log(a, "取消搜索·后续处理");
      });
    },
  },
  components: {
    CqLoading,
    Gantt,
  },
  computed: {
    uuid() {
      return this.$store.state.uuid;
    },
    ganttTotalWidth() {
      const whObj = {};
      let _width = this.$store.getters.ganttWidth;
      // console.log("是否有效甘特图尺寸参数", _width);
      if (
        this.$store.getters.printViewChangeFlag
      ) {
        _width = this.$store.getters.printTotalWidth;
        // console.log("拼凑全图模式");
      }
      whObj.width = _width + "px";

      if (this.$store.getters.printViewChangeFlag) {
        whObj.height = this.$store.getters.ganttHeight + "px";
      }
      return whObj;
    },
    isDragging() {
      return this.$store.state.isDragging;
    },
    moveLinkFlag() {
      return this.$store.state.moveLinkFlag;
    },
  },
};
</script>

<style lang="less">
::-webkit-scrollbar {
  width: 8px!important;
  height: 8px!important;
  overflow: visible;
}
::-webkit-scrollbar-track {
  background-color: #ffffff;
}
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.1);
}
.common-gantt {
  color: #000;
  background-color: #ffffff;
  /* position: absolute;
  top: 0;
  bottom: 0;
  left: 0; */
  width: 100%;
  height: 100%;

  margin: 0;
  padding: 0;
  user-select: none;
  font-family: "Microsoft YaHei", PingFangSC-Regular, "Helvetica Neue",
    Helvetica, Arial, "Hiragino Sans GB", "WenQuanYi Micro Hei", sans-serif;
  .box-content {
    border: 1px dashed #e1453e;
    margin-bottom: 20px;
  }
  .gantt-opts {
    opacity: 0;
    position: absolute;
    top: -50px;
    right: 0;
    z-index: 100000;
    background-color: rgba(0,0,0,0.3);
    height: 40px;
    color: red;
    box-sizing: border-box;
    font-size: 14px;
    line-height: 14px;
    ::v-deep el-select{
      height: 20px;
    }
  }

  .panel{
    position: absolute;
    z-index: 1005;
    background-color: rgba(0,0,0,0.1);
    top: 0;
    width: 25px;
    height: 100%;
    &.panel-pre{
      left: 0;
    }
    &.panel-next{
      right: 0;
    }
  }

  .loading-mask{
    position: absolute;
    z-index: 1599;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.1);
  }

}
// 右键菜单
.custom-class-hfxie{
  color: blue !important;
  .menu_body{
    .menu_item__available:hover,
    .menu_item_expand {
        background: #ffecf2 !important;
        color: #ff4050 !important;
    }
    .menu_item__available{
      color: #000 !important;
    }
  }
}
</style>
